// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

import { useTranslation } from '@crehana/i18n';
import Facebook from '@crehana/icons/fill/Facebook';
import Linkedin from '@crehana/icons/fill/Linkedin';
import Twitter from '@crehana/icons/fill/Twitter';
import Instagram from '@crehana/icons/Instagram';
import { shareOnSocialNetwork } from '@crehana/utils';

const ICONS_PROPS = {
  size: 18,
  ignoreColor: true,
  className: 'fill-current text-primary-main md:mb-24',
};

type SHARE_LINKS = 'facebook' | 'instagram' | 'linkedin' | 'twitter';

type socialMediaProps = {
  media: React.ReactNode;
  socialNetwork: SHARE_LINKS;
};
const SOCIAL_MEDIA: socialMediaProps[] = [
  { media: <Facebook {...ICONS_PROPS} />, socialNetwork: 'facebook' },
  { media: <Instagram {...ICONS_PROPS} />, socialNetwork: 'instagram' },
  { media: <Linkedin {...ICONS_PROPS} />, socialNetwork: 'linkedin' },
  { media: <Twitter {...ICONS_PROPS} />, socialNetwork: 'twitter' },
];

const SocialMedia = () => {
  const { t } = useTranslation();

  const shared = (socialNetwork: SHARE_LINKS) => {
    shareOnSocialNetwork({
      // @ts-expect-error
      socialNetwork,
      url: window.location.href,
    });
  };
  return (
    <div
      className="mx-auto flex items-center flex-col mt-112 sm:mt-80 lg:absolute top-0 right-0"
      style={{ right: -65, top: 56 }}
    >
      <p className="font-subtitle2 text-primary-main mb-12 lg:hidden">
        {t('SHARE_RESOURCE')}
      </p>
      <div
        className="w-full flex justify-between lg:flex-col"
        style={{ maxWidth: 219 }}
      >
        {SOCIAL_MEDIA.map(({ media, socialNetwork }, index) => (
          <button
            key={index.toString()}
            type="button"
            onClick={() => shared(socialNetwork)}
          >
            {media}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SocialMedia;
